<div class="app-isf-ocr-quick-fix-bl-details">
  <div class="app-isf-ocr-quick-fix-bl-details__header">
    <div class="app-isf-ocr-quick-fix-bl-details__header__left">
      <p class="app-isf-ocr-quick-fix-bl-details__header__title">
        {{ "LABELS.BILL_OF_LADING_DETAILS" | translate | uppercase }}
      </p>
      <app-hint-tooltip-icon [hint]="'INFO.BL.SUB_TITLE_RAIL' | translate"></app-hint-tooltip-icon>
    </div>
  </div>

  <p>{{ "LABELS.CHOOSE_TYPE_OF_BL" | translate }}</p>

  <form [formGroup]="formGroup" autocomplete="off">
    <div class="d-flex justify-content-between">
      <div class="card card-step bl-type" [ngClass]="{ 'is-selected': blControl.value === enumIsfShipmentCode.OCEAN }">
        <div class="card-header">
          <app-radio-button
            [control]="blControl"
            [id]="'bl-type-master'"
            [label]="'FORM_LABEL.MASTER'"
            [value]="enumIsfShipmentCode.OCEAN"
            [name]="'bl-type'"
          ></app-radio-button>
        </div>
        <div class="card-body px-3">
          <span>{{ "FORM_HELPER.FULL_CONTAINER" | translate }}</span>
        </div>
      </div>
      <div class="card card-step bl-type" [ngClass]="{ 'is-selected': blControl.value === enumIsfShipmentCode.HOUSE }">
        <div class="card-header">
          <app-radio-button
            [control]="blControl"
            [id]="'bl-type-house'"
            [label]="'FORM_LABEL.HOUSE'"
            [value]="enumIsfShipmentCode.HOUSE"
            [name]="'bl-type'"
          ></app-radio-button>
        </div>
        <div class="card-body px-3">
          <span>{{ "FORM_HELPER.LESS_THAN_CONTAINER_LOAD" | translate }}</span>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <div class="bl-type-info">
        <p>
          {{
            (blControl.value === enumIsfShipmentCode.HOUSE
              ? "LABELS.FILL_IN_YOUR_AMS_HOUSE_INFORMATION"
              : "LABELS.FILL_IN_YOUR_AMS_MASTER_INFORMATION"
            ) | translate
          }}
        </p>
      </div>

      <div class="form-row">
        <div class="col-6">
          <app-control-wrapper [control]="billFormGroup.get('carrier')" [errors]="errors.billCarrier">
            <label for="billCarrier" control-label>{{ "LABELS.CARRIER" | translate }}</label>
            <input
              type="text"
              [formControl]="billFormGroup.get('carrier')"
              class="form-control"
              id="billCarrier"
              name="billCarrier"
              [placeholder]="'FORM_PLACEHOLDER.CARRIER_CODE' | translate"
              [mask]="'S{4}'"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH'"
              [maxMaskLength]="4"
              control-wrapper
            />
          </app-control-wrapper>
        </div>
        <div class="col-6">
          <app-control-wrapper [control]="billFormGroup.get('number')" [errors]="errors.billNumber">
            <label for="billCarrier" control-label>{{ "LABELS.BL" | translate }}</label>
            <input
              type="text"
              [formControl]="billFormGroup.get('number')"
              class="form-control"
              id="billNumber"
              name="billNumber"
              [placeholder]="'FORM_PLACEHOLDER.BILL_NUMBER' | translate"
              [mask]="'A{12}'"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS'"
              [maxMaskLength]="12"
              control-wrapper
            />
          </app-control-wrapper>
        </div>
      </div>
    </div>
  </form>
  <missing-fields [code]="'LABELS.ISF'" (decline)="onSubmit(false)"></missing-fields>
</div>
